<template>
  <div style="position: relative">
    <v-card flat>
      <v-container fluid class="grey lighten-4" pa-0>
        <v-row no-gutters style="container-data-filter-buttons">
          <v-col class="align-self-center" md="auto" xs="auto" sm="auto">
            <!-- Back button -->
            <crud-button
              x-large
              color="blue-grey darken-1"
              @clicked="back()"
              icon="fa-chevron-left"
              :tooltip="$t('global.crud.buttons.return')"
            />
          </v-col>
          <v-col
            cols="1"
            class="flex-grow-1 flex-shrink-0 container-data-filter-info"
          >
            <v-container fluid pa-0>
              <v-row>
                <v-col sm="12" cols="12">
                  <div class="form-field-name">
                    {{ $t("productsTypesOperations.productType") }}
                  </div>
                  <div class="form-field-value">
                    {{ productType }}
                  </div>
                </v-col>
              </v-row>
            </v-container></v-col
          >
        </v-row>
      </v-container>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
            <crud-button
              x-large
              color="light-blue lighten-2"
              @clicked="create()"
              icon="fa-plus"
              :tooltip="$t('global.crud.button.add')"
            />
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="refreshItemsView()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.code">
                <td>
                  <!-- Edit record -->
                  <crud-button
                    x-small
                    color="orange"
                    icon="fa-pen"
                    :tooltip="$t('global.crud.buttons.edit')"
                    @clicked="edit(item.code)"
                  ></crud-button>

                  <!-- Delete record -->
                  <crud-button
                    v-if="
                      item.deletionDate === undefined ||
                        item.deletionDate === null
                    "
                    x-small
                    color="red"
                    icon="fa-trash"
                    :tooltip="$t('global.crud.buttons.delete')"
                    @clicked="suspend(item.code)"
                  ></crud-button>
                </td>
                <td>
                  <v-tooltip
                    right
                    v-if="item.agency !== undefined && item.agency !== null"
                  >
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.agency.code }}</span>
                    </template>
                    <span>{{ item.agency.name }}</span>
                  </v-tooltip>
                </td>
                <td>{{ item.volumeFrom }}</td>
                <td>{{ item.volumeTo }}</td>
                <td>{{ item.weightFrom }}</td>
                <td>{{ item.weightTo }}</td>
                <td>{{ item.time }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
      <validation-observer ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card>
          <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="details-list">
            <v-form>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    v-if="!editMode"
                    :name="$t('productsTypesOperations.agency')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="item.agencyCode"
                      :items="agenciesItems"
                      :loading="agencies.isLoading"
                      :search-input.sync="agencies.search"
                      hide-no-data
                      :no-data-text="$t('global.autocomplete.noDataFound')"
                      item-text="description"
                      item-value="code"
                      :label="$t('productsTypesOperations.agency')"
                      :placeholder="$t('global.autocomplete.starTypingToSearch')"
                      @focus="agencies.isEdit = true"
                      @change="agencies.isEdit = false"
                      :error-messages="errors"
                      clearable
                    ></v-autocomplete>
                  </validation-provider>
                  <v-text-field
                    v-else
                    :label="$t('productsTypesOperations.agency')"
                    v-model="item.agencyString"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm6">
                  <validation-provider
                    :name="$t('productsTypesOperations.volumeFrom')"
                    rules="decimal:5,4"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesOperations.volumeFrom')"
                      v-model="item.volumeFrom"
                      type="decimal"
                      @keypress="decimalOnlyField($event)"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
                <v-flex class="sm6">
                  <validation-provider
                    :name="$t('productsTypesOperations.volumeTo')"
                    rules="decimal:7,4"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesOperations.volumeTo')"
                      v-model="item.volumeTo"
                      type="decimal"
                      @keypress="decimalOnlyField($event)"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm6">
                  <validation-provider
                    :name="$t('productsTypesOperations.weightFrom')"
                    rules="decimal:5,4"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesOperations.weightFrom')"
                      v-model="item.weightFrom"
                      type="decimal"
                      @keypress="decimalOnlyField($event)"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
                <v-flex class="sm6">
                  <validation-provider
                    :name="$t('productsTypesOperations.weightTo')"
                    rules="decimal:7,4"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesOperations.weightTo')"
                      v-model="item.weightTo"
                      type="decimal"
                      @keypress="decimalOnlyField($event)"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    :name="$t('productsTypesOperations.time')"
                    rules="required|max:30"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesOperations.time')"
                      v-model="item.time"
                      required
                      :error-messages="errors"
                      @keypress="integerOnlyField($event)"
                      counter="30"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click.native="close()">
              {{ $t("global.buttons.close") }}
            </v-btn>
            <v-btn v-if="editMode" color="orange" text @click="passes(update)">
              {{ $t("global.buttons.update") }}
            </v-btn>
            <v-btn v-else color="green" text @click="passes(save)">
              {{ $t("global.buttons.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";

const CONTEXT = "/productsTypesOperations";
const CONTEXT_AGENCIES = "/agencies";
const ENTITY_NAME = "productTypeOperation.";

export default {
  components: {
    CrudButton
  },
  name: "ProductsTypesOperations",
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: false,
    searchTableWaiting: false,
    editMode: false,
    dialog: false,
    item: {},
    items: [],
    filter: {
      allFields: ""
    },
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    agencies: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    }
  }),
  computed: {
    formTitle() {
      return this.editMode
        ? this.$t("productsTypesOperations.title.edit")
        : this.$t("productsTypesOperations.title.new");
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("productsTypesOperations.datatable.agency"),
          value: ENTITY_NAME + "agencyCode"
        },
        {
          text: this.$t("productsTypesOperations.datatable.volumeFrom"),
          value: ENTITY_NAME + "volumeFrom"
        },
        {
          text: this.$t("productsTypesOperations.datatable.volumeTo"),
          value: ENTITY_NAME + "volumeTo"
        },
        {
          text: this.$t("productsTypesOperations.datatable.weightFrom"),
          value: ENTITY_NAME + "weightFrom"
        },
        {
          text: this.$t("productsTypesOperations.datatable.weightTo"),
          value: ENTITY_NAME + "weightTo"
        },
        {
          text: this.$t("productsTypesOperations.datatable.time"),
          value: ENTITY_NAME + "time"
        }
      ];
    },
    agenciesItems() {
      return this.agencies.entries.map(entry => {
        const description = entry.code + " - " + entry.name;
        return Object.assign({}, entry, { description });
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.allFields": function() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    },
    "agencies.search": function(value) {
      this.preLoadGenericSearchEntity(value, this.agencies, CONTEXT_AGENCIES);
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      localhttp
        .post(CONTEXT + "/allPagination/" + this.productType, this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    preLoadGenericSearchEntity(value, object, context, aditionalFilter) {
      if (!object.isLoadingWaiting) {
        setTimeout(() => {
          this.genericSearchEntity(object, context, aditionalFilter);
          object.isLoadingWaiting = false;
        }, 500);
      }
      object.value = value;
      object.isLoadingWaiting = true;
    },
    async genericSearchEntity(object, context, aditionalFilter) {
      // Items have already been requested
      if (!object.isEdit || object.value === null || object.value === "")
        return;

      if (object.isLoading) return;

      object.isLoading = true;

      let filterGeneric = {
        allFields: object.value
      };
      if (aditionalFilter !== undefined) {
        Object.keys(aditionalFilter).forEach(
          key => (filterGeneric[key] = aditionalFilter[key])
        );
      }

      // Lazily load input items
      localhttp
        .post(context + "/allFilter", filterGeneric)
        .then(response => {
          console.debug(response.data);
          object.entries = response.data;
        })
        .catch(e => {
          console.log(e);
          this.$showError();
        })
        .finally(() => (object.isLoading = false));
    },
    create() {
      console.debug("Create element");
      this.editMode = false;
      this.resetDialog();
      this.dialog = true;
    },
    async save() {
      console.debug("Save form");
      this.item.productTypeCode = this.productType;
      localhttp
        .post(CONTEXT + "/create", this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    edit(id) {
      console.debug("Edit element " + id);
      this.editMode = true;
      this.resetDialog();
      localhttp
        .get(CONTEXT + "/" + id)
        .then(response => {
          this.item = response.data;
          this.editPrepare(this.item);
          this.dialog = true;
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    editPrepare(item) {
      item.agencyString = item.agency.code + " - " + item.agency.name;
    },
    async update() {
      console.debug("Update form");
      localhttp
        .put(CONTEXT + "/update/" + this.item.code, this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async suspend(id) {
      console.debug("Suspend element " + id);
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("global.action.suspend.confirm"),
          { color: "blue" }
        )
      ) {
        localhttp
          .put(CONTEXT + "/delete/" + id)
          .then(response => {
            console.log(response.data);
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$showErrorCode(e.response.status);
          });
      }
    },
    refreshItemsView() {
      this.search();
    },
    close() {
      this.dialog = false;
    },
    resetDialog() {
      this.item = {};
      this.resetAgenciesSearch();
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    resetAgenciesSearch() {
      this.agencies.search = "";
      this.agencies.entries = [];
    },
    back() {
      this.$router.push({
        name: "productsTypes"
      });
    }
  },
  beforeMount() {
    this.productType = this.$props.productType;
  }
};
</script>
